import { render, staticRenderFns } from "./MLBXCQ.vue?vue&type=template&id=79786204&scoped=true"
import script from "./MLBXCQ.vue?vue&type=script&lang=js"
export * from "./MLBXCQ.vue?vue&type=script&lang=js"
import style0 from "./MLBXCQ.vue?vue&type=style&index=0&id=79786204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79786204",
  null
  
)

export default component.exports